import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA }
	from '@angular/material/dialog';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { MatRippleModule, MatOptionModule } from '@angular/material/core';
import { NgFor } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { pageTransitions } from '../../../../../shared/animations/page-transitions';
import { NotificationResponse, SubscriberService, Subscriptions } from '../../../../models/user-notification';
import { UserCardService } from '../../../../services/user-card.service';

@Component({
	selector: 'copo-add-subscription-dialog',
	templateUrl: './dialog-add-subscription.component.html',
	styleUrl: './dialog-add-subscription.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [

		MatButtonModule,
		MatIconModule,
		TranslateModule,

		MatFormFieldModule,

		MatSelectModule,
		NgFor,

		MatOptionModule,
		MatRippleModule
	]
})
export class AddSubscriptionDialogComponent implements OnInit {
	userId?: string;
	orgId?: string;
	selectedServiceId?: string;
	selectedSubscriptionId?: string;
	subscriberFrequency?: number;
	servicesSubscriptions?: SubscriberService[];
	subscriptions?: Subscriptions[];
	frequencies?: string[] = [];
	selectedFrequency?: string;
	services = new FormControl('');
	notificationResponse?: NotificationResponse;
	routeSub: Subscription = Subscription.EMPTY;
	userServiceSub: Subscription = Subscription.EMPTY;
	servicesSub: Subscription = Subscription.EMPTY;
	subscriptionSub: Subscription = Subscription.EMPTY;
	frequenciesSub: Subscription = Subscription.EMPTY;
	notificationSub: Subscription = Subscription.EMPTY;

	constructor(

		@Inject(MAT_DIALOG_DATA) public data: { userId: string; orgId: string },

		private readonly dialogRef: MatDialogRef<AddSubscriptionDialogComponent>,
		private readonly userCardService: UserCardService,

		private readonly snackBar: MatSnackBar
	) {
		this.userId = data.userId;
		this.orgId = data.orgId;
		this.getServices();
	}

	ngOnInit() {
		this.dialogRef.updateSize('50%');
	}

	getServices() {
		if (!this.userId || !this.orgId) {
			return;
		}
		this.servicesSub = this.userCardService.getServicesLinkedToSubscription(this.userId, this.orgId)
			.subscribe(value => {
				this.servicesSubscriptions = value;
			});
	}

	getSubscriptions() {
		if (!this.userId || !this.orgId || !this.selectedServiceId) {
			return;
		}
		this.subscriptionSub = this.userCardService.getSubscriptionsOfService(
			this.userId,
			this.orgId,
			this.selectedServiceId
		).subscribe(value => {
			this.subscriptions = value;
		});
	}

	serviceChanged() {
		if (!this.selectedServiceId) {
			return;
		}
		this.getSubscriptions();
	}

	subscriptionChanged(event: MatSelectChange) {
		const subsID: string = <string> event.value;
		this.getFrequenciesForSubscriptions(subsID);
	}

	getFrequenciesForSubscriptions(subscriptionID: string) {
		this.frequencies = [];
		this.frequenciesSub = this.userCardService.getFrequenciesOfSubscription(subscriptionID)
			.subscribe(value => {
				if (value.isDaily === 1) {
					this.frequencies?.push('Daily');
				}
				if (value.isEventDriven === 1) {
					this.frequencies?.push('Immediately');
				}
				if (value.isMonthly === 1) {
					this.frequencies?.push('Monthly');
				}
				if (value.isWeekly === 1) {
					this.frequencies?.push('Weekly');
				}
			});
	}

	sendNotification() {
		if (this.selectedServiceId && this.selectedSubscriptionId && this.selectedFrequency && this.userId) {
			if (this.selectedFrequency === 'Immediately') {
				this.subscriberFrequency = 0;
			}
			if (this.selectedFrequency === 'Daily') {
				this.subscriberFrequency = 1;
			}
			if (this.selectedFrequency === 'Weekly') {
				this.subscriberFrequency = 7;
			}
			if (this.selectedFrequency === 'Monthly') {
				this.subscriberFrequency = 30;
			}

			if (this.subscriberFrequency !== undefined) {
				this.notificationResponse = {
					details: true,
					frequency: this.subscriberFrequency,
					organizationId: Number(this.orgId),
					subscriberId: this.selectedSubscriptionId,
					notificationStatus: true
				};
			}

			if (!this.notificationResponse) {
				return;
			}

			this.notificationSub = this.userCardService.addNotification(this.notificationResponse, this.userId)
				.subscribe(
					{
						next: () => {
							this.dialogRef.close();
						},
						error: (err: unknown) => {
							console.error(err);
							if (err instanceof HttpErrorResponse) {
								this.displayErrorMessage((<{ code: string }>err.error).code);
							}
						}
					}
				);
		}
	}

	closeDialog() {
		this.dialogRef.close();
	}

	displayErrorMessage(errMsg: string) {
		this.snackBar.open(errMsg, undefined, {
			duration: 3000
		});
	}
}
